module.exports = __webpack_public_path__ + "img/astral-txt_1.f4e47725.svg";